import { Service, Provider, LeadSource } from './types';

export const SERVICES: Service[] = [
  {
    id: 'demo',
    name: 'NextAgency Demonstration',
    description: 'For agencies exploring how NextAgency can simplify their operations.',
    duration: '45 minutes'
  },
  {
    id: 'support',
    name: 'NextAgency Training / Tech Support',
    description: 'For agencies needing hands-on help or guidance with NextAgency.',
    duration: '30 minutes'
  },
  {
    id: 'kickoff',
    name: 'NextAgency Kickoff Meeting',
    description: 'For new agencies getting started: migration, setup, and Q&A.',
    duration: '45 minutes'
  }
];

export const PROVIDERS: Provider[] = [
  {
    id: 'samuel',
    name: 'Samuel',
    title: 'Support and Sales Specialist'
  },
  {
    id: 'vinil',
    name: 'Vinil',
    title: 'Support Specialist'
  },
  {
    id: 'shawn',
    name: 'Shawn',
    title: 'Support Specialist'
  },
  {
    id: 'ramon',
    name: 'Ramon',
    title: 'Support Specialist'
  }
];

export const LEAD_SOURCES: { value: LeadSource; label: string }[] = [
  { value: 'none', label: 'Select one...' },
  { value: 'email', label: 'Email' },
  { value: 'capterra', label: 'Capterra' },
  { value: 'g2', label: 'G2' },
  { value: 'search', label: 'Web Search' },
  { value: 'llms', label: 'AI Assistant (ChatGPT, Perplexity, etc.)' },
  { value: 'ease', label: 'Ease' },
  { value: 'perfectquote', label: 'PerfectQuote' },
  { value: 'industry_event', label: 'Industry Event' },
  { value: 'personal_referral', label: 'Personal Referral' },
  { value: 'other', label: 'Other' },
];

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

export const TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Phoenix', label: 'Arizona (MST)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)' }
];
